/* GRAVURWELT Personalisierung
 * Liest die Konfiguration aus dem Produkt-Metafeld gravurwelt.personalisierung (JSON) und baut daraus
 * Eingabefelder, Pflichtprüfung je Variante und eine Live-Vorschau. Die Eingaben werden als
 * Bestellpositions-Eigenschaften (properties[...]) mit dem normalen Produktformular übertragen.
 */
(function () {
  var root = document.querySelector('[data-pz]');
  if (!root) return;
  var CFG = JSON.parse(root.querySelector('[data-pz-config]').textContent);
  var G = JSON.parse(root.querySelector('[data-pz-global]').textContent);
  var formId = root.getAttribute('data-form');
  var form = document.getElementById(formId);
  var fieldsEl = root.querySelector('[data-pz-fields]');
  var prevEl = root.querySelector('[data-pz-preview]');
  var linesEl = root.querySelector('[data-pz-lines]');
  var product = root.closest('[data-product]') || document;

  var COLORS = {
    schwarz: '#232323', black: '#1d1d1d', 'vintage black': '#2a2a2a', grau: '#9a9a98', grey: '#8f8f8f', gray: '#8f8f8f', 'vintage grey': '#8d8d8a',
    weiß: '#f4f4f1', weiss: '#f4f4f1', white: '#f7f7f5', 'bottle green': '#1f4d3a', denim: '#3d5a80', 'true pink': '#e48fad', sand: '#d9c8a5',
    'sage green': '#9caf88', cornflower: '#6f8fd6', red: '#b52b2b', orange: '#e07a2e', olive: '#6b6b3a', mustard: '#d4a017', light: '#efece3',
    'light blue': '#a9c9e8', brown: '#6b4a2f', 'dusky pink': '#d6a8a6', charcoal: '#3a3a3c', birch: '#ebe4d2', navy: '#1f2a44',
    'cloud grey': '#cfcfcd', 'dusty turquoise': '#7fb7b2', peach: '#f2c4a8', almond: '#e9dcc4', lime: '#c7e38a', mint: '#a8e3cc',
    magenta: '#c2185b', 'light pink': '#f6bfd2', turquoise: '#3fc3c3', blue: '#2b4c9b', green: '#2e7d32', beige: '#e6dbc4', hellgrau: '#cfcfcd'
  };

  /* ---------- Hilfen ---------- */
  function h(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) e.setAttribute(k, attrs[k]); });
    if (html !== undefined) e.innerHTML = html;
    return e;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function selectedOptions() {
    var out = {};
    product.querySelectorAll('[data-option]').forEach(function (fs) {
      var lg = fs.querySelector('legend'); var c = fs.querySelector('input:checked');
      if (lg && c) out[lg.textContent.trim()] = c.value;
    });
    return out;
  }
  function matches(w, opts) {
    if (!w) return true;
    var v = opts[w.opt];
    if (v === undefined) return false;
    if (w['in'] && w['in'].indexOf(v) === -1) return false;
    if (w.not && w.not.indexOf(v) > -1) return false;
    if (w.has && !w.has.some(function (s) { return v.indexOf(s) > -1; })) return false;
    if (w.hasNot && w.hasNot.some(function (s) { return v.indexOf(s) > -1; })) return false;
    return true;
  }
  function colorOf(name) {
    if (!name) return null;
    var n = name.toLowerCase().trim();
    if (COLORS[n]) return COLORS[n];
    var first = n.split(/[\/ ]+/)[0];
    if (COLORS[first]) return COLORS[first];
    for (var k in COLORS) if (n.indexOf(k) === 0) return COLORS[k];
    return null;
  }
  function luminance(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); if (!m) return 1;
    var n = parseInt(m[1], 16); var r = n >> 16 & 255, g = n >> 8 & 255, b = n & 255;
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }
  function fmtDate(v) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || ''); return m ? m[3] + '.' + m[2] + '.' + m[1] : v; }

  /* ---------- Felder bauen ---------- */
  var state = {};
  var ctrls = {};
  var fontIdx = {};
  function fontSet(f) { return f && f.set === 'gravur' && G.gfonts && G.gfonts.length ? G.gfonts : G.fonts; }
  CFG.fields.forEach(function (f) {
    var wrap = h('div', { 'class': 'pz-field', 'data-id': f.id });
    var id = 'pz-' + f.id;
    var label = h('label', { 'for': id }, esc(f.label) + (f.required ? ' <span class="pz-req" aria-hidden="true">*</span>' : ''));
    wrap.appendChild(label);
    var name = 'properties[' + f.label.replace(/\s*\(optional\)\s*/i, '').trim() + ']';
    var ctl;
    if (f.type === 'text' || f.type === 'date') {
      ctl = h('input', { 'class': 'in', type: f.type === 'date' ? 'date' : 'text', id: id, maxlength: f.max || null, placeholder: f.placeholder || null, form: formId, autocomplete: 'off' });
      if (f.type === 'date') {
        // Datum als TT.MM.JJJJ in die Bestellung übernehmen
        var hd = h('input', { type: 'hidden', form: formId });
        hd.setAttribute('data-name', name);
        wrap.appendChild(hd);
        ctrls[f.id + ':hidden'] = hd;
      } else ctl.setAttribute('data-name', name);
    } else if (f.type === 'textarea') {
      ctl = h('textarea', { 'class': 'in', id: id, rows: f.rows || 3, maxlength: f.max || null, placeholder: f.placeholder || null, form: formId });
      ctl.setAttribute('data-name', name);
    } else if (f.type === 'select') {
      ctl = h('select', { 'class': 'in', id: id, form: formId });
      ctl.appendChild(h('option', { value: '' }, 'Bitte wählen …'));
      f.options.forEach(function (o) { ctl.appendChild(h('option', { value: o }, esc(o))); });
      ctl.setAttribute('data-name', name);
    } else if (f.type === 'file') {
      ctl = h('input', { 'class': 'in', type: 'file', id: id, form: formId, accept: '.png,.jpg,.jpeg,.pdf,.svg,.ai,.eps,.dst,.pes,.exp' });
      ctl.setAttribute('data-name', name);
    } else if (f.type === 'font') {
      ctl = h('div', { 'class': 'pz-fonts', role: 'radiogroup', 'aria-label': f.label, id: id });
      var FONTS = fontSet(f);
      FONTS.forEach(function (fo, i) {
        var lab = h('label', { 'class': 'pz-font' });
        var r = h('input', { type: 'radio', name: 'pz-font-pick-' + f.id, value: f.set === 'gravur' ? fo.name : (i + 1) + ' · ' + fo.name });
        r.addEventListener('change', function () { state[f.id] = r.value; fontIdx[f.id] = i; hidden.value = r.value; update(f.id); });
        lab.appendChild(r);
        lab.appendChild(h('span', { 'class': 'pz-font__sample', style: 'font-family:' + fo.css + ';font-weight:' + fo.weight + (fo.upper ? ';text-transform:uppercase' : '') }, 'Sophie'));
        lab.appendChild(h('span', { 'class': 'pz-font__name' }, f.set === 'gravur' ? esc(fo.name) : (i + 1) + '. ' + esc(fo.name)));
        ctl.appendChild(lab);
      });
      var hidden = h('input', { type: 'hidden', form: formId });
      hidden.setAttribute('data-name', name);
      wrap.appendChild(hidden);
      ctrls[f.id + ':hidden'] = hidden;
    } else if (f.type === 'thread') {
      ctl = h('div', { 'class': 'pz-threads', role: 'radiogroup', 'aria-label': f.label, id: id });
      G.threads.forEach(function (t) {
        var lab = h('label', { 'class': 'pz-thread', title: t.name });
        var r = h('input', { type: 'radio', name: 'pz-thread-pick', value: t.name });
        r.addEventListener('change', function () { state[f.id] = t.name; hiddenT.value = t.name; update(f.id); });
        lab.appendChild(r);
        lab.appendChild(h('span', { 'class': 'pz-thread__dot', style: 'background:' + t.hex }));
        lab.appendChild(h('span', { 'class': 'pz-thread__name' }, esc(t.name)));
        ctl.appendChild(lab);
      });
      var hiddenT = h('input', { type: 'hidden', form: formId });
      hiddenT.setAttribute('data-name', name);
      wrap.appendChild(hiddenT);
      ctrls[f.id + ':hidden'] = hiddenT;
    }
    if (f.type === 'date') ['input', 'change'].forEach(function (ev) { ctl.addEventListener(ev, function () { ctrls[f.id + ':hidden'].value = fmtDate(ctl.value); }); });
    if (ctl.tagName === 'INPUT' || ctl.tagName === 'TEXTAREA' || ctl.tagName === 'SELECT') {
      ctl.addEventListener('input', function () { state[f.id] = f.type === 'file' ? (ctl.files && ctl.files[0] ? ctl.files[0].name : '') : ctl.value; update(f.id); if (f.requiredUnless === undefined) CFG.fields.forEach(function (o) { if (o.requiredUnless === f.id) clearErr(o.id); }); });
      ctl.addEventListener('change', function () { state[f.id] = f.type === 'file' ? (ctl.files && ctl.files[0] ? ctl.files[0].name : '') : ctl.value; update(f.id); if (f.requiredUnless === undefined) CFG.fields.forEach(function (o) { if (o.requiredUnless === f.id) clearErr(o.id); }); });
    }
    wrap.appendChild(ctl);
    if (f.max && (f.type === 'text' || f.type === 'textarea')) wrap.appendChild(h('span', { 'class': 'pz-count', 'data-count': f.id }, '0 / ' + f.max));
    if (f.help) wrap.appendChild(h('span', { 'class': 'pz-help' }, esc(f.help)));
    wrap.appendChild(h('span', { 'class': 'pz-err', 'data-err': f.id, role: 'alert' }));
    fieldsEl.appendChild(wrap);
    ctrls[f.id] = ctl;
  });

  /* ---------- Sichtbarkeit, Formularnamen, Vorschau ---------- */
  function visible(f, opts) {
    if (f.whenAny) return f.whenAny.some(function (w) { return matches(w, opts); });
    return matches(f.when, opts);
  }
  function clearErr(id) {
    var w = fieldsEl.querySelector('[data-id="' + id + '"]'); if (!w) return;
    w.classList.remove('pz-field--err'); var e = w.querySelector('[data-err]'); if (e) e.textContent = '';
  }
  function update(changedId) {
    if (changedId) clearErr(changedId);
    var opts = selectedOptions();
    var anyVisible = false;
    CFG.fields.forEach(function (f) {
      var vis = visible(f, opts);
      var wrap = fieldsEl.querySelector('[data-id="' + f.id + '"]');
      wrap.hidden = !vis;
      if (vis && f.id !== 'hinweis') anyVisible = true;
      // Nur sichtbare Felder werden mitgesendet
      var el = ctrls[f.id + ':hidden'] || ctrls[f.id];
      if (el.getAttribute('data-name')) {
        if (vis) el.setAttribute('name', el.getAttribute('data-name')); else el.removeAttribute('name');
      }
      var cnt = wrap.querySelector('[data-count]');
      if (cnt) cnt.textContent = (state[f.id] || '').length + ' / ' + f.max;
    });
    root.classList.toggle('pz--empty', !anyVisible);
    renderPreview(opts);
  }
  function fontFor() {
    var ff = CFG.fields.filter(function (x) { return x.type === 'font'; })[0];
    var set = fontSet(ff);
    if (!ff || fontIdx[ff.id] === undefined) return set[0];
    return set[fontIdx[ff.id]] || set[0];
  }
  function renderPreview(opts) {
    var p = CFG.preview || {};
    var bg = '#f4f1ec';
    if (p.bg === 'holz') bg = 'holz';
    else if (p.bg && p.bg.indexOf('opt:') === 0) bg = colorOf(opts[p.bg.slice(4)]) || '#ece7df';
    else if (p.bg) bg = p.bg;
    var ink;
    if (CFG.type === 'stick') {
      var t = G.threads.filter(function (x) { return x.name === state.garn; })[0];
      ink = t ? t.hex : (luminance(bg) < 0.5 ? '#f4f1ea' : '#1d1b19');
    } else if (p.inkField) {
      var fd = CFG.fields.filter(function (x) { return x.id === p.inkField; })[0];
      ink = (fd && fd.colors && fd.colors[state[p.inkField]]) || '#1d1b19';
    } else if (p.ink) ink = p.ink;
    else if (bg === 'holz') ink = '#4a2b14';
    else ink = luminance(bg) < 0.5 ? '#e9dcc7' : '#6b5a48'; // Lasergravur: hell auf dunkler Glasur, dunkel auf hell
    prevEl.className = 'pz-prev pz-prev--' + CFG.type + (bg === 'holz' ? ' pz-prev--holz' : '');
    prevEl.style.background = bg === 'holz' ? '' : bg;
    var fo = fontFor();
    var html = '';
    CFG.fields.forEach(function (f) {
      if (!f.preview || !visible(f, opts)) return;
      var v = state[f.id] || '';
      if (f.type === 'date') v = fmtDate(v);
      var empty = !v;
      var txt = empty ? (f.placeholder ? f.placeholder.replace(/^z\. ?B\.\s*/, '') : f.label) : v;
      html += '<div class="pz-line' + (empty ? ' pz-line--ph' : '') + '"><span class="pz-line__lbl">' + esc(f.label.replace(/\s*\(optional\)\s*/i, '')) + '</span>' +
        '<span class="pz-line__txt" style="' + esc('font-family:' + fo.css + ';font-weight:' + fo.weight + ';color:' + ink + (fo.upper ? ';text-transform:uppercase' : '')) + '">' + esc(txt).replace(/\n/g, '<br>') + '</span></div>';
    });
    linesEl.innerHTML = html || '<div class="pz-line pz-line--ph"><span class="pz-line__txt">Für diese Auswahl ist keine Personalisierung nötig.</span></div>';
    var thread = CFG.type === 'stick' && state.garn ? ' · Garn: ' + state.garn : '';
    root.querySelector('[data-pz-caption]').textContent = 'Vorschau – ' + (CFG.type === 'stick' ? 'Stickerei' : CFG.type === 'gravur' ? 'Gravur' : 'Druck') + thread + '. Die Vorschau zeigt Text, Schrift und Farbe – Größe und Position auf dem Produkt können abweichen.';
  }

  /* ---------- Pflichtprüfung beim Absenden ---------- */
  function validate() {
    var opts = selectedOptions(); var first = null;
    CFG.fields.forEach(function (f) {
      var err = fieldsEl.querySelector('[data-err="' + f.id + '"]'); err.textContent = '';
      fieldsEl.querySelector('[data-id="' + f.id + '"]').classList.remove('pz-field--err');
      if (!f.required || !visible(f, opts)) return;
      if (f.requiredUnless && state[f.requiredUnless]) return;
      var v = (state[f.id] || '').toString().trim();
      if (!v) {
        err.textContent = f.type === 'font' || f.type === 'thread' || f.type === 'select' ? 'Bitte auswählen.' : f.type === 'file' ? 'Bitte Datei hochladen.' : 'Bitte ausfüllen.';
        fieldsEl.querySelector('[data-id="' + f.id + '"]').classList.add('pz-field--err');
        if (!first) first = f.id;
      }
    });
    if (first) {
      var el = fieldsEl.querySelector('[data-id="' + first + '"]');
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var inp = el.querySelector('input:not([type=hidden]),textarea,select'); if (inp) setTimeout(function () { inp.focus(); }, 300);
      return false;
    }
    return true;
  }
  if (form) {
    form.setAttribute('enctype', 'multipart/form-data');
    form.addEventListener('submit', function (e) {
      if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      // Leere optionale Felder nicht mitsenden
      root.querySelectorAll('[name^="properties["]').forEach(function (el) {
        var empty = el.type === 'file' ? !(el.files && el.files.length) : !String(el.value || '').trim();
        if (empty) el.removeAttribute('name');
      });
      setTimeout(update, 0);
    }, true);
  }
  product.addEventListener('change', function (e) { if (e.target.closest('[data-option]')) setTimeout(update, 0); });
  update();
})();
